import { useWindowSize } from "usehooks-ts";

const TAILWIND_MD_BREAKPOINT = 768;

const useIsMobile = () => {
  const { width } = useWindowSize();
  return { isMobile: width <= TAILWIND_MD_BREAKPOINT };
};

export default useIsMobile;
